import {HttpClient} from "../../http/HttpClient.jsx";
import {message} from "antd";
import {StringBuilder} from "../../AppUtils.js";
import moment from "moment";
import {isEmpty} from "lodash";

export const createBrief = async values => {
    const startTime = moment(
        `${moment(values.date).format("YYYY-MM-DD")} ${values.time.format("HH:mm")}`,
        "YYYY-MM-DD HH:mm"
    );
    const dtstart = startTime.toDate().getTime();
    const briefValues = {
        ...values,
        dtstart,
        floor: Number(values.floor),
        maxPrice: Number(values.maxPrice),
        participantsAmount: Number(values.participantsAmount)
    };

    const res = await HttpClient.safePost(`/api/brief/create`, briefValues);

    if (res.error) {
        message.error(new StringBuilder("שגיאה בעת יצירת הצעת מחיר").append(`(${res.error})`).toString());
    } else {
        message.success("הצעת מחיר נוצרה בהצלחה");
    }

    return res;
};

export const removeBriefFromProvider = async (briefId, providerId, declineReason, declineComment) => {
    const res = await HttpClient.safePost(`/api/brief/${briefId}/removeProvider`, {
        providerId,
        ...(declineReason ? {declineReason} : {}),
        ...(declineComment ? {declineComment} : {})
    });

    if (res.error) {
        message.error(new StringBuilder("שגיאה בעת הסרת בריף").append(`(${res.error})`).toString());
    } else {
        message.success("בריף הוסר בהצלחה");
    }

    return res;
};

export const cancelBid = async (briefId, bidId) => {
    const res = await HttpClient.safePost(`/api/brief/${briefId}/cancelProviderBid`, {bidId});

    if (res.error) {
        message.error(new StringBuilder("שגיאה בעת ביטול הצעת מחיר").append(`(${res.error})`).toString());
    } else {
        message.success("הצעת מחיר בוטלה בהצלחה");
    }

    return res;
};

export const updateAdminCommentByAdmin = async (briefId, adminCommentToUpdate, updatedAt) => {
    const res = await HttpClient.safePost(`/admin/api/briefs/${briefId}/updateBrief?updatedAt=${updatedAt}`, {
        brief: {adminComment: adminCommentToUpdate}
    });

    if (res?.error) {
        message.error("שגיאה, ההערה על הבריף לא נשמרה");
        return;
    }

    message.success("ההערה על הבריף נשמרה בהצלחה");

    return res;
};

export const updateAdminComment = async (briefId, adminCommentToUpdate, updatedAt) => {
    const res = await HttpClient.safePost(`/api/briefs/${briefId}/updateBrief?updatedAt=${updatedAt}`, {
        brief: {adminComment: adminCommentToUpdate}
    });

    if (res?.error) {
        message.error("שגיאה, ההערה על הבריף לא נשמרה");
        return;
    }

    message.success("ההערה על הבריף נשמרה בהצלחה");

    return res;
};

export const updateAssignedCSMsByAdmin = async (briefId, assignedCSMs, updatedAt) => {
    const res = await HttpClient.safePost(`/admin/api/briefs/${briefId}/updateBrief?updatedAt=${updatedAt}`, {
        brief: {assignedCSMs}
    });

    if (res?.status === 409) {
        message.error(res?.error);
        return;
    }

    if (res?.error) {
        message.error(`שגיאה בעת עדכון מנהלת לקוח | מזהה הבריף ${briefId}`);
        return;
    }

    message.success("בריף עודכן בהצלחה");

    return res;
};

export const updateAssignedCSMs = async (briefId, assignedCSMs, updatedAt) => {
    const res = await HttpClient.safePost(`/api/briefs/${briefId}/updateBrief?updatedAt=${updatedAt}`, {
        brief: {assignedCSMs}
    });

    if (res?.status === 409) {
        message.error(res?.error);
        return;
    }

    if (res?.error) {
        message.error(`שגיאה בעת עדכון מנהלת לקוח | מזהה הבריף ${briefId}`);
        return;
    }

    message.success("בריף עודכן בהצלחה");

    return res;
};

export const updateBriefStatus = async (
    briefId,
    status,
    updatedAt,
    whoToSendUpdateEmail = [],
    cancelReason,
    cancelComment,
    providerId
) => {
    const res = await HttpClient.safePost(`/api/briefs/${briefId}/updateStatus?updatedAt=${updatedAt}`, {
        status,
        ...(whoToSendUpdateEmail?.length ? {whoToSendUpdateEmail} : {}),
        ...(cancelReason ? {cancelReason} : {}),
        ...(cancelComment ? {cancelComment} : {}),
        ...(providerId ? {providerId} : {})
    });

    if (res?.error) {
        message.error("שגיאה בעת עדכון סטטוס לבריף");
        return;
    }

    message.success("סטטוס בריף עודכן בהצלחה");

    return res;
};

export const updateBriefStatusByAdmin = async (
    briefId,
    status,
    updatedAt,
    whoToSendUpdateEmail = [],
    cancelReason,
    cancelComment
) => {
    const res = await HttpClient.safePost(`/admin/api/briefs/${briefId}/updateStatus?updatedAt=${updatedAt}`, {
        status,
        ...(whoToSendUpdateEmail?.length ? {whoToSendUpdateEmail} : {}),
        ...(cancelReason ? {cancelReason} : {}),
        ...(cancelComment ? {cancelComment} : {})
    });

    if (res?.error) {
        message.error("שגיאה בעת עדכון סטטוס לבריף");
        return;
    }

    message.success("סטטוס בריף עודכן בהצלחה");

    return res;
};

export const updateBriefByAdmin = async (briefId, brief, updatedAt) => {
    const res = await HttpClient.safePost(`/admin/api/briefs/${briefId}/updateBrief?updatedAt=${updatedAt}`, {
        brief: brief
    });

    if (res?.error) {
        message.error(new StringBuilder().append("שגיאה, בריף לא נשלח לספקים", " | ").append(res?.error).toString());
        return;
    }

    message.success("בריף נשלח לספקים בהצלחה");

    return res;
};

export const updateBrief = async (briefId, brief, updatedAt) => {
    const res = await HttpClient.safePost(`/api/briefs/${briefId}/updateBrief?updatedAt=${updatedAt}`, {
        brief: brief
    });

    if (res?.error) {
        message.error("שגיאה, בריף לא נשלח לספקים");
        return;
    }

    message.success("בריף נשלח לספקים בהצלחה");

    return res;
};

export const sendReminderToCompany = async briefId => {
    const res = await HttpClient.safePost(`/api/briefs/${briefId}/sendReminderToCompany`);

    if (res?.error) {
        message.error("שגיאה בעת שליחת תזכורת ללקוח");
        return;
    }

    message.success("התזכורת נשלחה ללקוח בהצלחה");

    return res;
};

export const sendReminderToProvider = async (briefId, providerId) => {
    const res = await HttpClient.safePost(`/api/briefs/${briefId}/sendReminderToProvider`, {providerId});

    if (res?.error) {
        message.error("שגיאה בעת שליחת תזכורת לספק");
        return;
    }

    message.success("התזכורת נשלחה לספק בהצלחה");

    return res;
};
